function initData(){
  // console.log("--登录用户初始化--",window.sessionStorage.getItem('loginUser'))
  const  tv=null!=window.sessionStorage.getItem('loginUser')? JSON.parse(window.sessionStorage.getItem('loginUser')): {name:'访客'};
  window.sessionStorage.removeItem('loginUser');
  return tv;
}

const loginUser={
  // namespaced:true,
  state: {
    loginUser: initData()
  },
  getters: {
    loginUserData: state => state.loginUser
  },
  mutations: {
    setLoginUser(state, data) {//设置导航信息
      state.loginUser = data;
    },
    //重置用戶
    resetLoginUser(state, data) {//设置导航信息
      // console.log("--重置登录用户了---")
      state.loginUser =initData();
    }
  },
  actions: {// 管理mutations
    SET_LOGINUSER(context, data) {//添加
      // console.log('放入数据了：：',data)
      context.commit('setLoginUser', data);
    },
    //重置
    RESET_LOGINUSER(context, data) {//添加
      window.sessionStorage.removeItem('loginUser');
      context.commit('resetLoginUser', data);
    }
  }
}
export default loginUser;



// WEBPACK FOOTER //
// ./src/store/loginUser.js